import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const BottleDeposit = (props) => {
  const { cartOrOrder } = props;

  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { bottleDepositTotal } = cartOrOrder;

  if (!bottleDepositTotal || bottleDepositTotal === 0) {
    return null;
  }

  return (
    <div className="c7-order-summary__item">
      <div className="c7-order-summary__title">
        {t('checkout.general.bottleDeposit')}
      </div>
      <div className="c7-order-summary__value">
        {currencyFormat(bottleDepositTotal, currency)}
      </div>
    </div>
  );
};

export default BottleDeposit;
